export const EVENT_PENDING_TOKEN = "EVENT_PENDING_TOKEN";
export const EVENT_CREATE_TOKEN = "EVENT_CREATE_TOKEN";
